/**
 * Multi-language translations
 * English, Spanish, Patois (Jamaican Creole)
 * Comprehensive translations for all major pages
 */

const translations = {
  en: {
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      success: "Success",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      search: "Search",
      filter: "Filter",
      all: "All",
      back: "Back",
      next: "Next",
      submit: "Submit",
      confirm: "Confirm",
      close: "Close",
      viewAll: "View All",
      seeMore: "See More",
      noResults: "No results found",
      tryAgain: "Try Again",
      required: "Required",
      optional: "Optional",
    },
    // Navbar
    navbar: {
      shop: "Shop",
      sell: "Sell",
      ship: "Ship",
      joinUs: "Join Us",
      coverage: "Coverage",
      cart: "Cart",
      login: "Login",
      logout: "Logout",
      account: "Account",
      tagline: "Jamaica Delivery",
      myOrders: "My Orders",
      dashboard: "Dashboard",
    },
    // Shop Page
    shop: {
      title: "Tropical Marketplace",
      subtitle: "Fresh from Jamaica",
      searchPlaceholder: "Search products, stores...",
      categories: "Categories",
      allCategories: "All Categories",
      featuredSellers: "Featured Sellers",
      featuredProducts: "Featured Products",
      newArrivals: "New Arrivals",
      bestSellers: "Best Sellers",
      viewStore: "View Store",
      addToCart: "Add to Cart",
      outOfStock: "Out of Stock",
      inStock: "In Stock",
      price: "Price",
      rating: "Rating",
      reviews: "reviews",
      filters: "Filters",
      sortBy: "Sort By",
      priceRange: "Price Range",
      clearFilters: "Clear Filters",
      applyFilters: "Apply Filters",
      noProducts: "No products found",
      loadMore: "Load More",
      products: "Products",
      stores: "Stores",
      freeDelivery: "Free Delivery",
      fastDelivery: "Fast Delivery",
    },
    // Product
    product: {
      description: "Description",
      specifications: "Specifications",
      reviews: "Reviews",
      relatedProducts: "Related Products",
      quantity: "Quantity",
      addToCart: "Add to Cart",
      buyNow: "Buy Now",
      shareProduct: "Share Product",
      wishlist: "Add to Wishlist",
      inWishlist: "In Wishlist",
      seller: "Seller",
      sku: "SKU",
      category: "Category",
      available: "Available",
      soldOut: "Sold Out",
      limitedStock: "Limited Stock",
    },
    // Cart
    cart: {
      title: "Shopping Cart",
      empty: "Your cart is empty",
      emptyMessage: "Looks like you haven't added anything to your cart yet.",
      continueShopping: "Continue Shopping",
      subtotal: "Subtotal",
      shipping: "Shipping",
      tax: "Tax",
      total: "Total",
      checkout: "Proceed to Checkout",
      remove: "Remove",
      update: "Update",
      quantity: "Qty",
      itemsInCart: "items in cart",
      freeShipping: "Free Shipping",
      estimatedDelivery: "Estimated Delivery",
      applyCoupon: "Apply Coupon",
      couponCode: "Coupon Code",
      apply: "Apply",
      discount: "Discount",
      orderSummary: "Order Summary",
    },
    // Checkout
    checkout: {
      title: "Checkout",
      shippingAddress: "Shipping Address",
      billingAddress: "Billing Address",
      paymentMethod: "Payment Method",
      reviewOrder: "Review Order",
      placeOrder: "Place Order",
      processing: "Processing...",
      selectAddress: "Select Address",
      addNewAddress: "Add New Address",
      deliveryOptions: "Delivery Options",
      standardDelivery: "Standard Delivery",
      expressDelivery: "Express Delivery",
      pickupPoint: "PUDO Pickup Point",
      payOnDelivery: "Pay on Delivery",
      cardPayment: "Card Payment",
      mobilePayment: "Mobile Payment",
      orderNotes: "Order Notes",
      notesPlaceholder: "Any special instructions for your order...",
      termsAgree: "I agree to the Terms & Conditions",
      secureCheckout: "Secure Checkout",
      sslEncrypted: "SSL Encrypted",
    },
    // Order Confirmation
    orderConfirm: {
      title: "Order Confirmed!",
      thankYou: "Thank you for your order",
      orderNumber: "Order Number",
      confirmationEmail: "A confirmation email has been sent to",
      trackOrder: "Track Order",
      continueShopping: "Continue Shopping",
      estimatedDelivery: "Estimated Delivery",
      orderDetails: "Order Details",
    },
    // Auth
    auth: {
      login: "Login",
      register: "Register",
      signIn: "Sign In",
      signUp: "Sign Up",
      email: "Email",
      phone: "Phone Number",
      password: "Password",
      confirmPassword: "Confirm Password",
      forgotPassword: "Forgot Password?",
      resetPassword: "Reset Password",
      createAccount: "Create Account",
      alreadyHaveAccount: "Already have an account?",
      dontHaveAccount: "Don't have an account?",
      rememberMe: "Remember me",
      orContinueWith: "Or continue with",
      welcomeBack: "Welcome back!",
      createYourAccount: "Create your account",
      enterEmail: "Enter your email or phone",
      enterPassword: "Enter your password",
    },
    // Dashboard
    dashboard: {
      welcome: "Welcome",
      myAccount: "My Account",
      quickActions: "Quick Actions",
      recentOrders: "Recent Orders",
      notifications: "Notifications",
      viewAll: "View All",
      orderHistory: "Order History",
      savedAddresses: "Saved Addresses",
      paymentMethods: "Payment Methods",
      accountSettings: "Account Settings",
      helpSupport: "Help & Support",
    },
    // Orders
    orders: {
      title: "My Orders",
      orderPlaced: "Order Placed",
      processing: "Processing",
      shipped: "Shipped",
      outForDelivery: "Out for Delivery",
      delivered: "Delivered",
      cancelled: "Cancelled",
      trackOrder: "Track Order",
      orderDetails: "Order Details",
      total: "Total",
      items: "items",
      reorder: "Reorder",
      cancelOrder: "Cancel Order",
      returnItem: "Return Item",
      viewInvoice: "View Invoice",
    },
    // Tracking
    tracking: {
      title: "Track Your Order",
      trackingCode: "Tracking Code",
      status: "Status",
      eta: "Estimated Arrival",
      driver: "Your Driver",
      deliveryAddress: "Delivery Address",
      orderSummary: "Order Summary",
      history: "Tracking History",
      callDriver: "Call Driver",
      messageDriver: "Message Driver",
      liveTracking: "Live Tracking",
    },
    // Rewards
    rewards: {
      title: "Liantiao Rewards",
      points: "Points",
      tier: "Tier",
      earnPoints: "Earn Points",
      redeemRewards: "Redeem Rewards",
      vouchers: "My Vouchers",
      history: "Points History",
      howToEarn: "How to Earn Points",
      bronze: "Bronze",
      silver: "Silver",
      gold: "Gold",
      platinum: "Platinum",
    },
    // Shipping Addresses
    shipping: {
      title: "Shipping Addresses",
      addAddress: "Add Address",
      addPudo: "Add PUDO",
      editAddress: "Edit Address",
      deleteAddress: "Delete Address",
      setDefault: "Set as Default",
      default: "Default",
      home: "Home",
      work: "Work",
      pudo: "PUDO Pickup",
      recipientName: "Recipient Name",
      phone: "Phone Number",
      streetAddress: "Street Address",
      city: "City",
      parish: "Parish",
      postalCode: "Postal Code",
      instructions: "Delivery Instructions",
      noAddresses: "No addresses saved",
      maxAddresses: "Maximum 10 addresses allowed",
    },
    // Footer
    footer: {
      aboutUs: "About Us",
      contactUs: "Contact Us",
      careers: "Careers",
      press: "Press",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      helpCenter: "Help Center",
      faq: "FAQ",
      shipping: "Shipping Info",
      returns: "Returns",
      sellOnLiantiao: "Sell on Liantiao",
      becomeDriver: "Become a Driver",
      partnerWithUs: "Partner with Us",
      followUs: "Follow Us",
      newsletter: "Newsletter",
      subscribeText: "Subscribe to get updates on deals and new products",
      enterEmail: "Enter your email",
      subscribe: "Subscribe",
      copyright: "© 2025 Liantiao. All rights reserved.",
    },
    // Seller
    seller: {
      dashboard: "Seller Dashboard",
      products: "My Products",
      orders: "Orders",
      analytics: "Analytics",
      addProduct: "Add Product",
      editProduct: "Edit Product",
      inventory: "Inventory",
      reviews: "Reviews",
      earnings: "Earnings",
      payouts: "Payouts",
      storeSettings: "Store Settings",
      storeName: "Store Name",
      storeDescription: "Store Description",
    },
  },

  // SPANISH TRANSLATIONS
  es: {
    // Common
    common: {
      loading: "Cargando...",
      error: "Ocurrió un error",
      success: "Éxito",
      cancel: "Cancelar",
      save: "Guardar",
      delete: "Eliminar",
      edit: "Editar",
      search: "Buscar",
      filter: "Filtrar",
      all: "Todo",
      back: "Atrás",
      next: "Siguiente",
      submit: "Enviar",
      confirm: "Confirmar",
      close: "Cerrar",
      viewAll: "Ver Todo",
      seeMore: "Ver Más",
      noResults: "Sin resultados",
      tryAgain: "Intentar de Nuevo",
      required: "Requerido",
      optional: "Opcional",
    },
    // Navbar
    navbar: {
      shop: "Comprar",
      sell: "Vender",
      ship: "Enviar",
      joinUs: "Únete",
      coverage: "Cobertura",
      cart: "Carrito",
      login: "Iniciar Sesión",
      logout: "Cerrar Sesión",
      account: "Cuenta",
      tagline: "Entrega Jamaica",
      myOrders: "Mis Pedidos",
      dashboard: "Panel",
    },
    // Shop Page
    shop: {
      title: "Mercado Tropical",
      subtitle: "Fresco de Jamaica",
      searchPlaceholder: "Buscar productos, tiendas...",
      categories: "Categorías",
      allCategories: "Todas las Categorías",
      featuredSellers: "Vendedores Destacados",
      featuredProducts: "Productos Destacados",
      newArrivals: "Nuevos Productos",
      bestSellers: "Más Vendidos",
      viewStore: "Ver Tienda",
      addToCart: "Agregar al Carrito",
      outOfStock: "Agotado",
      inStock: "Disponible",
      price: "Precio",
      rating: "Calificación",
      reviews: "reseñas",
      filters: "Filtros",
      sortBy: "Ordenar Por",
      priceRange: "Rango de Precio",
      clearFilters: "Limpiar Filtros",
      applyFilters: "Aplicar Filtros",
      noProducts: "No se encontraron productos",
      loadMore: "Cargar Más",
      products: "Productos",
      stores: "Tiendas",
      freeDelivery: "Envío Gratis",
      fastDelivery: "Entrega Rápida",
    },
    // Product
    product: {
      description: "Descripción",
      specifications: "Especificaciones",
      reviews: "Reseñas",
      relatedProducts: "Productos Relacionados",
      quantity: "Cantidad",
      addToCart: "Agregar al Carrito",
      buyNow: "Comprar Ahora",
      shareProduct: "Compartir Producto",
      wishlist: "Agregar a Favoritos",
      inWishlist: "En Favoritos",
      seller: "Vendedor",
      sku: "SKU",
      category: "Categoría",
      available: "Disponible",
      soldOut: "Agotado",
      limitedStock: "Stock Limitado",
    },
    // Cart
    cart: {
      title: "Carrito de Compras",
      empty: "Tu carrito está vacío",
      emptyMessage: "Parece que aún no has agregado nada a tu carrito.",
      continueShopping: "Continuar Comprando",
      subtotal: "Subtotal",
      shipping: "Envío",
      tax: "Impuesto",
      total: "Total",
      checkout: "Proceder al Pago",
      remove: "Eliminar",
      update: "Actualizar",
      quantity: "Cant",
      itemsInCart: "artículos en el carrito",
      freeShipping: "Envío Gratis",
      estimatedDelivery: "Entrega Estimada",
      applyCoupon: "Aplicar Cupón",
      couponCode: "Código de Cupón",
      apply: "Aplicar",
      discount: "Descuento",
      orderSummary: "Resumen del Pedido",
    },
    // Checkout
    checkout: {
      title: "Pago",
      shippingAddress: "Dirección de Envío",
      billingAddress: "Dirección de Facturación",
      paymentMethod: "Método de Pago",
      reviewOrder: "Revisar Pedido",
      placeOrder: "Realizar Pedido",
      processing: "Procesando...",
      selectAddress: "Seleccionar Dirección",
      addNewAddress: "Agregar Nueva Dirección",
      deliveryOptions: "Opciones de Entrega",
      standardDelivery: "Entrega Estándar",
      expressDelivery: "Entrega Express",
      pickupPoint: "Punto de Recogida PUDO",
      payOnDelivery: "Pago Contra Entrega",
      cardPayment: "Pago con Tarjeta",
      mobilePayment: "Pago Móvil",
      orderNotes: "Notas del Pedido",
      notesPlaceholder: "Instrucciones especiales para tu pedido...",
      termsAgree: "Acepto los Términos y Condiciones",
      secureCheckout: "Pago Seguro",
      sslEncrypted: "Cifrado SSL",
    },
    // Order Confirmation
    orderConfirm: {
      title: "¡Pedido Confirmado!",
      thankYou: "Gracias por tu pedido",
      orderNumber: "Número de Pedido",
      confirmationEmail: "Se ha enviado un correo de confirmación a",
      trackOrder: "Rastrear Pedido",
      continueShopping: "Continuar Comprando",
      estimatedDelivery: "Entrega Estimada",
      orderDetails: "Detalles del Pedido",
    },
    // Auth
    auth: {
      login: "Iniciar Sesión",
      register: "Registrarse",
      signIn: "Entrar",
      signUp: "Registrarse",
      email: "Correo Electrónico",
      phone: "Número de Teléfono",
      password: "Contraseña",
      confirmPassword: "Confirmar Contraseña",
      forgotPassword: "¿Olvidaste tu Contraseña?",
      resetPassword: "Restablecer Contraseña",
      createAccount: "Crear Cuenta",
      alreadyHaveAccount: "¿Ya tienes una cuenta?",
      dontHaveAccount: "¿No tienes una cuenta?",
      rememberMe: "Recordarme",
      orContinueWith: "O continúa con",
      welcomeBack: "¡Bienvenido de nuevo!",
      createYourAccount: "Crea tu cuenta",
      enterEmail: "Ingresa tu correo o teléfono",
      enterPassword: "Ingresa tu contraseña",
    },
    // Dashboard
    dashboard: {
      welcome: "Bienvenido",
      myAccount: "Mi Cuenta",
      quickActions: "Acciones Rápidas",
      recentOrders: "Pedidos Recientes",
      notifications: "Notificaciones",
      viewAll: "Ver Todo",
      orderHistory: "Historial de Pedidos",
      savedAddresses: "Direcciones Guardadas",
      paymentMethods: "Métodos de Pago",
      accountSettings: "Configuración de Cuenta",
      helpSupport: "Ayuda y Soporte",
    },
    // Orders
    orders: {
      title: "Mis Pedidos",
      orderPlaced: "Pedido Realizado",
      processing: "Procesando",
      shipped: "Enviado",
      outForDelivery: "En Camino",
      delivered: "Entregado",
      cancelled: "Cancelado",
      trackOrder: "Rastrear Pedido",
      orderDetails: "Detalles del Pedido",
      total: "Total",
      items: "artículos",
      reorder: "Volver a Pedir",
      cancelOrder: "Cancelar Pedido",
      returnItem: "Devolver Artículo",
      viewInvoice: "Ver Factura",
    },
    // Tracking
    tracking: {
      title: "Rastrea Tu Pedido",
      trackingCode: "Código de Rastreo",
      status: "Estado",
      eta: "Llegada Estimada",
      driver: "Tu Conductor",
      deliveryAddress: "Dirección de Entrega",
      orderSummary: "Resumen del Pedido",
      history: "Historial de Rastreo",
      callDriver: "Llamar al Conductor",
      messageDriver: "Mensaje al Conductor",
      liveTracking: "Rastreo en Vivo",
    },
    // Rewards
    rewards: {
      title: "Recompensas Liantiao",
      points: "Puntos",
      tier: "Nivel",
      earnPoints: "Ganar Puntos",
      redeemRewards: "Canjear Recompensas",
      vouchers: "Mis Cupones",
      history: "Historial de Puntos",
      howToEarn: "Cómo Ganar Puntos",
      bronze: "Bronce",
      silver: "Plata",
      gold: "Oro",
      platinum: "Platino",
    },
    // Shipping Addresses
    shipping: {
      title: "Direcciones de Envío",
      addAddress: "Agregar Dirección",
      addPudo: "Agregar PUDO",
      editAddress: "Editar Dirección",
      deleteAddress: "Eliminar Dirección",
      setDefault: "Establecer como Predeterminado",
      default: "Predeterminado",
      home: "Casa",
      work: "Trabajo",
      pudo: "Recogida PUDO",
      recipientName: "Nombre del Destinatario",
      phone: "Número de Teléfono",
      streetAddress: "Dirección",
      city: "Ciudad",
      parish: "Parroquia",
      postalCode: "Código Postal",
      instructions: "Instrucciones de Entrega",
      noAddresses: "No hay direcciones guardadas",
      maxAddresses: "Máximo 10 direcciones permitidas",
    },
    // Footer
    footer: {
      aboutUs: "Sobre Nosotros",
      contactUs: "Contáctanos",
      careers: "Carreras",
      press: "Prensa",
      terms: "Términos de Servicio",
      privacy: "Política de Privacidad",
      helpCenter: "Centro de Ayuda",
      faq: "Preguntas Frecuentes",
      shipping: "Info de Envío",
      returns: "Devoluciones",
      sellOnLiantiao: "Vende en Liantiao",
      becomeDriver: "Sé un Conductor",
      partnerWithUs: "Asóciate con Nosotros",
      followUs: "Síguenos",
      newsletter: "Boletín",
      subscribeText: "Suscríbete para recibir ofertas y nuevos productos",
      enterEmail: "Ingresa tu correo",
      subscribe: "Suscribirse",
      copyright: "© 2025 Liantiao. Todos los derechos reservados.",
    },
    // Seller
    seller: {
      dashboard: "Panel del Vendedor",
      products: "Mis Productos",
      orders: "Pedidos",
      analytics: "Analíticas",
      addProduct: "Agregar Producto",
      editProduct: "Editar Producto",
      inventory: "Inventario",
      reviews: "Reseñas",
      earnings: "Ganancias",
      payouts: "Pagos",
      storeSettings: "Config. de Tienda",
      storeName: "Nombre de Tienda",
      storeDescription: "Descripción de Tienda",
    },
  },

  // PATOIS (JAMAICAN CREOLE) TRANSLATIONS
  patois: {
    // Common
    common: {
      loading: "Loading...",
      error: "Sumpn guh wrang",
      success: "Bless up!",
      cancel: "Nuh badda",
      save: "Save it",
      delete: "Dash it weh",
      edit: "Fix it up",
      search: "Look fi",
      filter: "Sort out",
      all: "Everyting",
      back: "Guh back",
      next: "Guh deh",
      submit: "Sen it",
      confirm: "Yea man",
      close: "Lock it aff",
      viewAll: "See All",
      seeMore: "Check More",
      noResults: "Nutn nuh deh yah",
      tryAgain: "Try Again",
      required: "Haffi fill",
      optional: "If yuh want",
    },
    // Navbar
    navbar: {
      shop: "Shop",
      sell: "Sell",
      ship: "Sen It",
      joinUs: "Link Up",
      coverage: "Weh Wi Deh",
      cart: "Cart",
      login: "Sign In",
      logout: "Sign Out",
      account: "Account",
      tagline: "Jamaica Delivery",
      myOrders: "Mi Orda Dem",
      dashboard: "Dashboard",
    },
    // Shop Page
    shop: {
      title: "Tropical Marketplace",
      subtitle: "Fresh from Yaad",
      searchPlaceholder: "Look fi products, stores...",
      categories: "Categories",
      allCategories: "All Categories",
      featuredSellers: "Top Sellers",
      featuredProducts: "Top Products",
      newArrivals: "New Tings",
      bestSellers: "Hot Sellers",
      viewStore: "Check Store",
      addToCart: "Add to Cart",
      outOfStock: "Done Out",
      inStock: "Got it",
      price: "Price",
      rating: "Rating",
      reviews: "reviews",
      filters: "Filters",
      sortBy: "Sort By",
      priceRange: "Price Range",
      clearFilters: "Clear All",
      applyFilters: "Set Filters",
      noProducts: "No products deh yah",
      loadMore: "Load More",
      products: "Products",
      stores: "Stores",
      freeDelivery: "Free Drop Off",
      fastDelivery: "Quick Drop Off",
    },
    // Product
    product: {
      description: "About It",
      specifications: "Details",
      reviews: "Reviews",
      relatedProducts: "Similar Tings",
      quantity: "How Much",
      addToCart: "Add to Cart",
      buyNow: "Buy Now",
      shareProduct: "Share It",
      wishlist: "Save Fi Lata",
      inWishlist: "Saved",
      seller: "Seller",
      sku: "SKU",
      category: "Category",
      available: "Got it",
      soldOut: "Done Out",
      limitedStock: "Almost Done",
    },
    // Cart
    cart: {
      title: "Shopping Cart",
      empty: "Yuh cart empty",
      emptyMessage: "Yuh nuh add nutn to yuh cart yet.",
      continueShopping: "Guh Back Shop",
      subtotal: "Subtotal",
      shipping: "Delivery",
      tax: "Tax",
      total: "Total",
      checkout: "Checkout",
      remove: "Take Out",
      update: "Update",
      quantity: "Qty",
      itemsInCart: "tings inna cart",
      freeShipping: "Free Delivery",
      estimatedDelivery: "Soon Come",
      applyCoupon: "Use Coupon",
      couponCode: "Coupon Code",
      apply: "Use It",
      discount: "Discount",
      orderSummary: "Order Summary",
    },
    // Checkout
    checkout: {
      title: "Checkout",
      shippingAddress: "Weh Fi Drop It",
      billingAddress: "Billing Address",
      paymentMethod: "How Yuh Paying",
      reviewOrder: "Check Order",
      placeOrder: "Place Order",
      processing: "Working pan it...",
      selectAddress: "Pick Address",
      addNewAddress: "Add New Address",
      deliveryOptions: "Delivery Options",
      standardDelivery: "Regular Delivery",
      expressDelivery: "Quick Delivery",
      pickupPoint: "PUDO Pickup",
      payOnDelivery: "Pay When It Reach",
      cardPayment: "Card Payment",
      mobilePayment: "Mobile Payment",
      orderNotes: "Extra Notes",
      notesPlaceholder: "Any special ting fi tell wi...",
      termsAgree: "Mi agree to di Terms",
      secureCheckout: "Safe Checkout",
      sslEncrypted: "Secure",
    },
    // Order Confirmation
    orderConfirm: {
      title: "Order Confirm!",
      thankYou: "Give thanks fi yuh order",
      orderNumber: "Order Number",
      confirmationEmail: "Wi sen email to",
      trackOrder: "Track Order",
      continueShopping: "Shop More",
      estimatedDelivery: "Soon Come",
      orderDetails: "Order Details",
    },
    // Auth
    auth: {
      login: "Log In",
      register: "Sign Up",
      signIn: "Sign In",
      signUp: "Sign Up",
      email: "Email",
      phone: "Phone Numba",
      password: "Password",
      confirmPassword: "Confirm Password",
      forgotPassword: "Forget Password?",
      resetPassword: "Reset Password",
      createAccount: "Mek Account",
      alreadyHaveAccount: "Already have account?",
      dontHaveAccount: "Nuh have account?",
      rememberMe: "Remember mi",
      orContinueWith: "Or continue wid",
      welcomeBack: "Wah gwaan!",
      createYourAccount: "Mek yuh account",
      enterEmail: "Put yuh email or phone",
      enterPassword: "Put yuh password",
    },
    // Dashboard
    dashboard: {
      welcome: "Wah Gwaan",
      myAccount: "Mi Account",
      quickActions: "Quick Tings",
      recentOrders: "Recent Orda",
      notifications: "Notifications",
      viewAll: "See All",
      orderHistory: "Orda History",
      savedAddresses: "Saved Address Dem",
      paymentMethods: "Payment Methods",
      accountSettings: "Settings",
      helpSupport: "Help",
    },
    // Orders
    orders: {
      title: "Mi Orda Dem",
      orderPlaced: "Orda Place",
      processing: "Dem a work pan it",
      shipped: "Sen out",
      outForDelivery: "On di way",
      delivered: "Reach!",
      cancelled: "Cancel",
      trackOrder: "Track Order",
      orderDetails: "Orda Details",
      total: "Total",
      items: "tings",
      reorder: "Order Again",
      cancelOrder: "Cancel Order",
      returnItem: "Return It",
      viewInvoice: "See Invoice",
    },
    // Tracking
    tracking: {
      title: "Track Yuh Orda",
      trackingCode: "Tracking Code",
      status: "Status",
      eta: "Soon Come",
      driver: "Yuh Driver",
      deliveryAddress: "Weh fi drop it",
      orderSummary: "Wah inna di orda",
      history: "Tracking History",
      callDriver: "Call Driver",
      messageDriver: "Message Driver",
      liveTracking: "Live Tracking",
    },
    // Rewards
    rewards: {
      title: "Liantiao Blessings",
      points: "Points",
      tier: "Level",
      earnPoints: "Get Points",
      redeemRewards: "Collect Rewards",
      vouchers: "Mi Vouchers",
      history: "Points History",
      howToEarn: "How fi Get Points",
      bronze: "Bronze",
      silver: "Silver",
      gold: "Gold",
      platinum: "Platinum",
    },
    // Shipping Addresses
    shipping: {
      title: "Delivery Address Dem",
      addAddress: "Add Address",
      addPudo: "Add PUDO",
      editAddress: "Fix up Address",
      deleteAddress: "Dash weh Address",
      setDefault: "Mek dis di main one",
      default: "Main",
      home: "Yaad",
      work: "Wuk",
      pudo: "PUDO Pickup",
      recipientName: "Who fi get it",
      phone: "Phone Numba",
      streetAddress: "Street Address",
      city: "Town",
      parish: "Parish",
      postalCode: "Post Code",
      instructions: "Special Instructions",
      noAddresses: "No address save yet",
      maxAddresses: "Only 10 address allow",
    },
    // Footer
    footer: {
      aboutUs: "About Wi",
      contactUs: "Contact Wi",
      careers: "Jobs",
      press: "Press",
      terms: "Terms",
      privacy: "Privacy",
      helpCenter: "Help",
      faq: "FAQ",
      shipping: "Delivery Info",
      returns: "Returns",
      sellOnLiantiao: "Sell pan Liantiao",
      becomeDriver: "Be a Driver",
      partnerWithUs: "Partner wid Wi",
      followUs: "Follow Wi",
      newsletter: "Newsletter",
      subscribeText: "Sign up fi deals and new tings",
      enterEmail: "Yuh email",
      subscribe: "Subscribe",
      copyright: "© 2025 Liantiao. All rights reserved.",
    },
    // Seller
    seller: {
      dashboard: "Seller Dashboard",
      products: "Mi Products",
      orders: "Orders",
      analytics: "Stats",
      addProduct: "Add Product",
      editProduct: "Edit Product",
      inventory: "Inventory",
      reviews: "Reviews",
      earnings: "Earnings",
      payouts: "Payouts",
      storeSettings: "Store Settings",
      storeName: "Store Name",
      storeDescription: "Store Info",
    },
  },
};

export default translations;
